import { createAction, props } from "@ngrx/store";
import { CopayProcFeeDto } from "src/app/core/models/http/treatment/copay-procedure-fees/copay-proc-fee-dto";

export const loadSuccess = createAction(
  "[Copay Procedure Fee API] Load Success",
  props<{ copayProcedureFees: CopayProcFeeDto[] }>()
);

export const updateSuccess = createAction(
  "[Copay Procedure Fee API] Update Success"
);
